/*
 * @Author: your name
 * @Date: 2021-11-05 15:08:58
 * @LastEditTime: 2021-11-08 13:28:44
 * @LastEditors: your name
 * @Description: 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 * @FilePath: /burgeon-project-logic/src/config/minxin/verticalTableDetailCustomize.js
 */
import singleObjectActions from './singleObjectActions'
import subTableFormLinkage from './subTableFormLinkage'

export default () => ({
  mixins: [singleObjectActions(), subTableFormLinkage()],
  data() {
    return {}
  },
  watch: {},
  created() {},
  updated() {
    if (vm.$route.params.tableName == 'DC_B_RETURN_ORDER' && vm.$route.path.includes('TABLE_DETAIL')) {
      this.changeFormItemValue()
    }
    if (vm.$route.params.tableName == 'CP_C_PHY_WAREHOUSE') {
      setTimeout(() => {
        $(".ark-collapse-header").contents().each(function () {
          if (this.nodeType === 3 && this.nodeValue.trim() === "WMS信息") {
            $(this).replaceWith(
              'WMS信息.<span style="color:red;margin-left:8px;">若此仓库需要与门店宝/EC等系统交互，则“WMS仓库编码”、“奇门CustomerId”、“货主编码”等字段需填入值</span>'
            );
          }
        });
      }, 1500);
    }
  },
  mounted() {},
  methods: {
    // 客户退货单，单对象页面【复制】后， “单据日期”应该取当前日期， “出库日期”不应该赋值
    changeFormItemValue: _.debounce(function() {
      const page = vm.$store.state[R3.getModuleName()]
      if (!page.mainFormInfo) {
        return
      }
      const isCopy = page.mainFormInfo.formData.data.copy
      if (isCopy) {
        let arr = new Map([
          ['#BILL_DATE', new Date().format('yyyy-MM-dd')],
          ['#OUT_STOCK_TIME', ''],
        ]);
        for (let key of arr.keys()) {
          $(key)[0].__vue__.$parent.valueChange(arr.get(key)) // 触发主表表单项的change事件
        }
      }
    }, 1200)
  }
})
